/*
================================================
SPECIAL BRAND — Popup System
Black + Yellow Identity
================================================
*/

const SPECIAL_CONFIG = {

  /* ==================================================
     TIMING
  ================================================== */
  cartDelaySeconds: 15,

  /* ==================================================
     COUNTDOWN
  ================================================== */
  countdownSeconds: 900, // 15 Minutes

  /* ==================================================
     GENERAL
  ================================================== */
  showOnMobile: true,

  /* ==================================================
     FLOATING REMINDER
  ================================================== */
  floatingIcon: {
    enabled: true,
    tooltip: 'Your offer is still waiting',
    position: 'bottom-left'
  },

  /* ==================================================
     TRACKING
  ================================================== */
  tracking: {
    enabled: true
  },

  /* ==================================================
     POPUP CONTENT
  ================================================== */
  cartPopup: {

    accent: '#FFD400',
    dark: '#0F0F10',
    light: '#FFFFFF',

    tag: 'SPECIAL OFFER',

    headline: 'Choose your offer',

    body: 'Pick one deal and copy the code before it expires.',

    dismissText: 'No thanks',

    offers: [

      {
        icon: '🚚',

        /* Free Shipping sentence as ONE text */
        title: 'Free Shipping On orders over 750 EGP',

        description: '',

        code: 'FREESHIP',

        badge: ''
      },

      {
        icon: '🏷️',

        title: '5% OFF',

        description: 'Extra discount on your full order',

        code: 'SP5',

        badge: 'MOST POPULAR'
      }

    ]
  }
};


(function () {

  'use strict';


  /* ==================================================
     CONFIG
  ================================================== */

  const CFG = SPECIAL_CONFIG;

  const d = CFG.cartPopup;


  /* ==================================================
     CONDITIONS
  ================================================== */

  if (
    !CFG.showOnMobile &&
    /Mobi|Android/i.test(navigator.userAgent)
  ) return;


  if (
    window.location.pathname.includes('/checkout')
  ) return;



  /* ==================================================
     SESSION STORAGE KEYS
  ================================================== */

  const SK_TRIGGER =
    'sp_trigger_time';

  const SK_SHOWN =
    'sp_popup_shown';

  const SK_DISMISSED =
    'sp_dismissed';

  const SK_COPIED =
    'sp_code_copied';

  const SK_FLOAT =
    'sp_float_visible';



  function getTriggerTime() {

    return parseInt(
      sessionStorage.getItem(SK_TRIGGER) || '0',
      10
    );

  }


  function setTriggerTime() {

    sessionStorage.setItem(
      SK_TRIGGER,
      Date.now().toString()
    );

  }


  function wasShown() {

    return (
      sessionStorage.getItem(SK_SHOWN) === '1'
    );

  }


  function markShown() {

    sessionStorage.setItem(
      SK_SHOWN,
      '1'
    );

  }


  function wasDismissed() {

    return (
      sessionStorage.getItem(SK_DISMISSED) === '1'
    );

  }


  function markDismissed() {

    sessionStorage.setItem(
      SK_DISMISSED,
      '1'
    );

  }


  function wasCopied() {

    return (
      sessionStorage.getItem(SK_COPIED) === '1'
    );

  }


  function markCopied() {

    sessionStorage.setItem(
      SK_COPIED,
      '1'
    );

  }


  function isFloatVisible() {

    return (
      sessionStorage.getItem(SK_FLOAT) === '1'
    );

  }


  function setFloatVisible(v) {

    sessionStorage.setItem(
      SK_FLOAT,
      v ? '1' : '0'
    );

  }



  /* ==================================================
     VARIABLES
  ================================================== */

  let countdownTimer = null;

  let secondsLeft = 0;

  let selectedOffer = null;



  /* ==================================================
     META PIXEL TRACKING
  ================================================== */

  function track(
    eventName,
    params = {}
  ) {

    if (
      !CFG.tracking.enabled
    ) return;


    if (
      typeof fbq !== 'function'
    ) return;


    fbq(
      'trackCustom',
      eventName,
      { ...params }
    );

  }



  /* ==================================================
     COLOR HELPER
  ================================================== */

  function isLight(hex) {

    const c =
      hex.replace('#', '');


    const r =
      parseInt(
        c.substr(0, 2),
        16
      );


    const g =
      parseInt(
        c.substr(2, 2),
        16
      );


    const b =
      parseInt(
        c.substr(4, 2),
        16
      );


    return (

      (
        r * 299 +
        g * 587 +
        b * 114
      ) / 1000

      > 155

    );

  }



  /* ==================================================
     CSS
  ================================================== */

  const style =
    document.createElement('style');


  style.id =
    'sp-styles';


  style.textContent = `

    :root {

      --sp-accent: ${d.accent};

      --sp-dark: ${d.dark};

      --sp-light: ${d.light};

      --sp-radius: 24px;

      --sp-font:
        -apple-system,
        BlinkMacSystemFont,
        'Segoe UI',
        Arial,
        sans-serif;

    }



    /* =============================
       OVERLAY
    ============================= */

    #sp-overlay {

      display: none;

      position: fixed;

      inset: 0;

      z-index: 2147483647;

      background:
        rgba(0,0,0,0.62);

      backdrop-filter:
        blur(6px);

      align-items: center;

      justify-content: center;

      padding: 18px;

    }


    #sp-overlay.active {

      display: flex;

    }



    /* =============================
       POPUP
    ============================= */

    #sp-box {

      width: 430px;

      max-width: 100%;

      border-radius:
        var(--sp-radius);

      overflow: hidden;

      background:
        var(--sp-dark);

      color:
        var(--sp-light);

      box-shadow:
        0 30px 80px
        rgba(0,0,0,0.35);

      transform:
        translateY(20px)
        scale(0.96);

      opacity: 0;

      transition:
        transform .28s ease,
        opacity .28s ease;

      position: relative;

      font-family:
        var(--sp-font);

      border:
        3px solid
        var(--sp-accent);

    }


    #sp-box.open {

      transform:
        translateY(0)
        scale(1);

      opacity: 1;

    }



    /* =============================
       TOP BAR
    ============================= */

    #sp-topbar {

      height: 8px;

      background:
        repeating-linear-gradient(
          90deg,

          var(--sp-accent)
          0 18px,

          #111
          18px 24px
        );

    }



    /* =============================
       HEADER
    ============================= */

    #sp-header {

      padding:
        18px
        18px
        10px;

      background:

        radial-gradient(
          circle at top right,
          rgba(255,212,0,.18),
          transparent 34%
        ),

        radial-gradient(
          circle at bottom left,
          rgba(255,212,0,.12),
          transparent 36%
        ),

        var(--sp-dark);

    }



    #sp-head-row {

      display: flex;

      align-items:
        flex-start;

      justify-content:
        space-between;

      gap: 12px;

      margin-bottom: 12px;

    }



    /* =============================
       TAG
    ============================= */

    #sp-tag {

      display:
        inline-flex;

      align-items:
        center;

      gap: 8px;

      background:
        var(--sp-accent);

      color: #111;

      font-size: 11px;

      font-weight: 900;

      letter-spacing:
        .08em;

      text-transform:
        uppercase;

      padding:
        8px 12px;

      border-radius:
        999px;

      line-height: 1;

    }



    /* =============================
       CLOSE
    ============================= */

    #sp-close {

      width: 38px;

      height: 38px;

      border-radius: 50%;

      border: none;

      cursor: pointer;

      background:
        rgba(255,255,255,0.08);

      color: #fff;

      font-size: 16px;

      display: flex;

      align-items: center;

      justify-content: center;

      transition:
        .2s ease;

      flex-shrink: 0;

    }


    #sp-close:hover {

      background:
        rgba(255,255,255,0.16);

      transform:
        scale(1.05);

    }



    /* =============================
       TIMER
    ============================= */

    #sp-timer-wrap {

      display: flex;

      align-items: center;

      gap: 10px;

      margin-bottom: 14px;

    }


    #sp-timer {

      display:
        inline-flex;

      align-items: center;

      gap: 8px;

      background:
        rgba(255,212,0,.12);

      border:
        1px solid
        rgba(255,212,0,.22);

      color:
        var(--sp-accent);

      border-radius:
        999px;

      padding:
        8px 12px;

      font-size:
        13px;

      font-weight:
        800;

      line-height: 1;

    }



    /* =============================
       PROGRESS BAR
    ============================= */

    #sp-progress-track {

      height: 8px;

      width: 100%;

      background:
        rgba(255,255,255,0.08);

      border-radius:
        999px;

      overflow: hidden;

    }


    #sp-progress {

      height: 100%;

      width: 100%;

      background:

        linear-gradient(
          90deg,

          var(--sp-accent),

          #ffea75
        );

      border-radius:
        999px;

      transition:
        width 1s linear;

    }



    /* =============================
       MAIN CONTENT
    ============================= */

    #sp-content {

      background: #fff;

      color: #111;

      padding:
        20px
        18px
        18px;

      border-top-left-radius:
        24px;

      border-top-right-radius:
        24px;

    }



    #sp-title {

      margin:
        0 0 6px;

      font-size:
        28px;

      line-height:
        1.1;

      font-weight:
        900;

      color: #111;

    }



    #sp-subtitle {

      margin:
        0 0 18px;

      font-size:
        14px;

      line-height:
        1.6;

      color: #555;

    }



    /* =============================
       OFFERS
    ============================= */

    .sp-offers {

      display: grid;

      gap: 12px;

      margin-bottom:
        16px;

    }



    .sp-offer-card {

      display: flex;

      align-items:
        center;

      gap: 14px;

      border:
        2px solid
        #e9e9e9;

      border-radius:
        18px;

      padding: 14px;

      cursor: pointer;

      background: #fff;

      transition:
        .2s ease;

      position:
        relative;

    }



    .sp-offer-card:hover {

      transform:
        translateY(-2px);

      border-color:
        #d6d6d6;

      box-shadow:
        0 12px 30px
        rgba(0,0,0,0.06);

    }



    .sp-offer-card.selected {

      border-color:
        var(--sp-accent);

      background:
        #fffdf1;

      box-shadow:
        0 0 0 4px
        rgba(255,212,0,.16);

    }



    /* =============================
       OFFER ICON
    ============================= */

    .sp-offer-icon {

      width: 54px;

      height: 54px;

      flex-shrink: 0;

      border-radius:
        16px;

      background:
        var(--sp-accent);

      display: flex;

      align-items: center;

      justify-content: center;

      font-size: 26px;

      box-shadow:
        inset 0 -3px 0
        rgba(0,0,0,.12);

    }



    .sp-offer-copy {

      flex: 1;

      min-width: 0;

    }



    /* =============================
       OFFER TITLE

       IMPORTANT:
       Free Shipping + condition
       use same font / size / weight
    ============================= */

    .sp-offer-title-row {

      display: flex;

      align-items: center;

      gap: 8px;

      flex-wrap: wrap;

    }



    .sp-offer-title {

      margin: 0;

      font-size: 16px;

      font-weight: 800;

      line-height: 1.4;

      color: #111;

    }



    /* =============================
       OFFER BADGE
    ============================= */

    .sp-offer-badge {

      background: #111;

      color: #fff;

      font-size: 10px;

      font-weight: 800;

      letter-spacing:
        .04em;

      border-radius:
        999px;

      padding:
        5px 9px;

      text-transform:
        uppercase;

      line-height: 1;

    }



    /* =============================
       OFFER DESCRIPTION
    ============================= */

    .sp-offer-desc {

      margin:
        5px 0 0;

      font-size:
        14px;

      line-height:
        1.45;

      color:
        #4a4a4a;

      font-weight:
        700;

    }



    /* =============================
       CHECK
    ============================= */

    .sp-offer-check {

      width: 26px;

      height: 26px;

      border-radius:
        50%;

      background: #111;

      color:
        var(--sp-accent);

      display: none;

      align-items: center;

      justify-content: center;

      font-weight: 900;

      font-size: 13px;

      flex-shrink: 0;

    }


    .sp-offer-card.selected
    .sp-offer-check {

      display: flex;

    }



    /* =============================
       CODE SECTION
    ============================= */

    #sp-code-section {

      display: none;

      margin-top: 6px;

      margin-bottom:
        16px;

    }


    #sp-code-section.visible {

      display: block;

    }



    .sp-code-row {

      display: flex;

      align-items: center;

      gap: 10px;

      background: #111;

      border-radius:
        18px;

      padding: 12px;

    }



    .sp-code-meta {

      flex: 1;

      min-width: 0;

    }



    .sp-code-label {

      color:
        rgba(255,255,255,.74);

      font-size: 12px;

      margin:
        0 0 5px;

      font-weight:
        700;

    }



    .sp-code-val {

      color: #fff;

      font-size: 22px;

      line-height: 1;

      font-weight:
        900;

      letter-spacing:
        .08em;

      margin: 0;

      font-family:
        'Courier New',
        monospace;

    }



    /* =============================
       COPY BUTTON
    ============================= */

    #sp-copy-btn {

      border: none;

      cursor: pointer;

      border-radius:
        14px;

      padding:
        12px 16px;

      font-size:
        14px;

      font-weight:
        900;

      background:
        var(--sp-accent);

      color:
        ${isLight(d.accent) ? '#111' : '#fff'};

      white-space:
        nowrap;

      transition:
        .18s ease;

      box-shadow:
        inset 0 -3px 0
        rgba(0,0,0,.14);

    }


    #sp-copy-btn:hover {

      transform:
        translateY(-1px);

    }



    /* =============================
       DISMISS
    ============================= */

    #sp-dismiss {

      text-align: center;

      margin: 0;

      font-size:
        13px;

      color: #777;

      cursor: pointer;

      font-weight:
        700;

    }


    #sp-dismiss:hover {

      color: #111;

    }



    /* =============================
       SUCCESS
    ============================= */

    #sp-success {

      position: absolute;

      inset: 0;

      background:
        rgba(15,15,16,.97);

      display: none;

      align-items: center;

      justify-content: center;

      flex-direction: column;

      text-align: center;

      padding: 24px;

      gap: 10px;

    }


    #sp-success.show {

      display: flex;

    }



    #sp-success-icon {

      width: 78px;

      height: 78px;

      border-radius:
        50%;

      background:
        var(--sp-accent);

      display: flex;

      align-items: center;

      justify-content: center;

      color: #111;

      font-size:
        34px;

      font-weight:
        900;

      transform:
        scale(.85);

      transition:
        transform .25s ease;

    }


    #sp-success.show
    #sp-success-icon {

      transform:
        scale(1);

    }



    #sp-success-title {

      margin: 0;

      font-size:
        24px;

      color: #fff;

      font-weight:
        900;

    }


    #sp-success-sub {

      margin: 0;

      font-size:
        14px;

      line-height:
        1.6;

      color:
        rgba(255,255,255,.76);

      max-width:
        290px;

    }



    /* =============================
       FLOATING REMINDER
    ============================= */

    #sp-float {

      position: fixed;

      z-index:
        2147483646;

      bottom: 24px;

      display: none;

      flex-direction:
        column;

      gap: 8px;

      align-items:
        center;

      cursor: pointer;

      font-family:
        var(--sp-font);

    }


    #sp-float.left {

      left: 20px;

    }


    #sp-float.right {

      right: 20px;

    }


    #sp-float.visible {

      display: flex;

    }



    #sp-float-tooltip {

      background: #111;

      color: #fff;

      font-size: 11px;

      font-weight: 800;

      padding:
        7px 10px;

      border-radius:
        999px;

      box-shadow:
        0 10px 25px
        rgba(0,0,0,.18);

      white-space:
        nowrap;

    }



    #sp-float-btn {

      width: 58px;

      height: 58px;

      border-radius:
        50%;

      border:
        2px solid #111;

      background:
        var(--sp-accent);

      color: #111;

      font-size: 24px;

      font-weight: 900;

      cursor: pointer;

      box-shadow:
        0 16px 35px
        rgba(0,0,0,.18);

      position: relative;

      transition:
        .2s ease;

    }


    #sp-float-btn:hover {

      transform:
        translateY(-2px)
        scale(1.04);

    }



    #sp-float-pulse {

      position: absolute;

      inset: -4px;

      border-radius:
        50%;

      border:
        2px solid
        var(--sp-accent);

      opacity: 0;

      animation:
        spPulse
        2s
        ease-out
        infinite;

    }



    @keyframes spPulse {

      0% {

        transform:
          scale(1);

        opacity: .7;

      }

      100% {

        transform:
          scale(1.55);

        opacity: 0;

      }

    }



    /* =============================
       MOBILE
    ============================= */

    @media
    (max-width: 520px) {

      #sp-box {

        width: 100%;

      }


      #sp-title {

        font-size:
          24px;

      }


      .sp-offer-title {

        font-size:
          15px;

        font-weight:
          800;

      }


      .sp-offer-card {

        gap: 11px;

        padding: 12px;

      }


      .sp-offer-icon {

        width: 48px;

        height: 48px;

        font-size:
          23px;

      }


      .sp-code-row {

        flex-direction:
          column;

        align-items:
          stretch;

      }


      #sp-copy-btn {

        width: 100%;

      }

    }

  `;


  document.head.appendChild(
    style
  );



  /* ==================================================
     GENERATE OFFERS
  ================================================== */

  const offersHTML =
    d.offers

    .map(
      (o, i) => `

        <div
          class="sp-offer-card"
          data-index="${i}"
        >

          <div
            class="sp-offer-icon"
          >
            ${o.icon}
          </div>


          <div
            class="sp-offer-copy"
          >

            <div
              class="sp-offer-title-row"
            >

              <p
                class="sp-offer-title"
              >
                ${o.title}
              </p>


              ${
                o.badge
                ?
                `
                <span
                  class="sp-offer-badge"
                >
                  ${o.badge}
                </span>
                `
                :
                ''
              }

            </div>


            ${
              o.description
              ?
              `
              <p
                class="sp-offer-desc"
              >
                ${o.description}
              </p>
              `
              :
              ''
            }

          </div>


          <div
            class="sp-offer-check"
          >
            ✓
          </div>

        </div>

      `
    )

    .join('');



  /* ==================================================
     INJECT POPUP HTML
  ================================================== */

  document.body.insertAdjacentHTML(

    'beforeend',

    `

    <div id="sp-overlay">

      <div id="sp-box">


        <div id="sp-topbar"></div>


        <div id="sp-header">


          <div id="sp-head-row">


            <div id="sp-tag">

              ★ ${d.tag}

            </div>


            <button
              id="sp-close"
              aria-label="Close"
            >

              ✕

            </button>


          </div>


          <div id="sp-timer-wrap">

            <div id="sp-timer">

              ⏳

              <span id="sp-cd">

                15:00 left

              </span>

            </div>

          </div>


          <div id="sp-progress-track">

            <div id="sp-progress"></div>

          </div>


        </div>



        <div id="sp-content">


          <h3 id="sp-title">

            ${d.headline}

          </h3>


          <p id="sp-subtitle">

            ${d.body}

          </p>



          <div class="sp-offers">

            ${offersHTML}

          </div>



          <div id="sp-code-section">


            <div class="sp-code-row">


              <div class="sp-code-meta">


                <p class="sp-code-label">

                  Selected code

                </p>


                <p
                  class="sp-code-val"
                  id="sp-code-val"
                ></p>


              </div>


              <button id="sp-copy-btn">

                Copy Code

              </button>


            </div>


          </div>



          <p id="sp-dismiss">

            ${d.dismissText}

          </p>


        </div>



        <div id="sp-success">


          <div id="sp-success-icon">

            ✓

          </div>


          <p id="sp-success-title">

            Code copied!

          </p>


          <p id="sp-success-sub"></p>


        </div>


      </div>

    </div>



    <div
      id="sp-float"
      class="${
        CFG.floatingIcon.position ===
        'bottom-right'
        ?
        'right'
        :
        'left'
      }"
    >


      <div id="sp-float-tooltip">

        ${CFG.floatingIcon.tooltip}

      </div>


      <button
        id="sp-float-btn"
        aria-label="Open offer popup"
      >

        <div id="sp-float-pulse"></div>

        %

      </button>


    </div>

    `

  );



  /* ==================================================
     ELEMENTS
  ================================================== */

  const $overlay =
    document.getElementById(
      'sp-overlay'
    );


  const $box =
    document.getElementById(
      'sp-box'
    );


  const $bar =
    document.getElementById(
      'sp-progress'
    );


  const $cd =
    document.getElementById(
      'sp-cd'
    );


  const $codeSection =
    document.getElementById(
      'sp-code-section'
    );


  const $codeVal =
    document.getElementById(
      'sp-code-val'
    );


  const $copyBtn =
    document.getElementById(
      'sp-copy-btn'
    );


  const $closeBtn =
    document.getElementById(
      'sp-close'
    );


  const $dismiss =
    document.getElementById(
      'sp-dismiss'
    );


  const $success =
    document.getElementById(
      'sp-success'
    );


  const $successSub =
    document.getElementById(
      'sp-success-sub'
    );


  const $float =
    document.getElementById(
      'sp-float'
    );


  const $floatBtn =
    document.getElementById(
      'sp-float-btn'
    );



  /* ==================================================
     COUNTDOWN
  ================================================== */

  function renderCD() {

    const m =
      Math.floor(
        secondsLeft / 60
      );


    const s =
      secondsLeft % 60;


    $cd.textContent =
      `${m}:${String(s).padStart(2, '0')} left`;

  }



  /* ==================================================
     FLOATING BUTTON
  ================================================== */

  function showFloat() {

    if (
      !CFG.floatingIcon.enabled
    ) return;


    if (
      wasCopied()
    ) return;


    setFloatVisible(true);


    $float.classList.add(
      'visible'
    );

  }


  function hideFloat() {

    $float.classList.remove(
      'visible'
    );


    setFloatVisible(false);

  }



  if (
    isFloatVisible() &&
    !wasCopied()
  ) {

    $float.classList.add(
      'visible'
    );

  }



  /* ==================================================
     RESET POPUP
  ================================================== */

  function resetPopupState() {

    selectedOffer = null;


    $codeSection.classList.remove(
      'visible'
    );


    $codeVal.textContent =
      '';


    $copyBtn.textContent =
      'Copy Code';


    document

      .querySelectorAll(
        '.sp-offer-card'
      )

      .forEach(
        card => {

          card.classList.remove(
            'selected'
          );

        }
      );


    $success.classList.remove(
      'show'
    );

  }



  /* ==================================================
     SHOW POPUP
  ================================================== */

  function showPopup() {


    if (
      wasShown() &&
      !isFloatVisible()
    ) return;



    markShown();


    hideFloat();


    resetPopupState();



    const triggerTime =
      getTriggerTime();



    const elapsed =
      triggerTime
      ?
      Math.floor(

        (
          Date.now()
          -
          triggerTime
          -
          CFG.cartDelaySeconds * 1000
        )

        / 1000

      )
      :
      0;



    secondsLeft =
      Math.max(

        0,

        CFG.countdownSeconds
        -
        elapsed

      );



    if (
      secondsLeft <= 0
    ) {

      showFloat();

      return;

    }



    renderCD();



    $bar.style.transition =
      'none';



    $bar.style.width =

      Math.round(

        (
          secondsLeft
          /
          CFG.countdownSeconds
        )

        * 100

      )

      + '%';



    $overlay.classList.add(
      'active'
    );



    requestAnimationFrame(
      () => {

        requestAnimationFrame(
          () => {


            $box.classList.add(
              'open'
            );


            $bar.style.transition =
              `width ${secondsLeft}s linear`;


            $bar.style.width =
              '0%';


          }
        );

      }
    );



    clearInterval(
      countdownTimer
    );



    countdownTimer =
      setInterval(
        () => {


          secondsLeft--;


          if (
            secondsLeft <= 0
          ) {


            clearInterval(
              countdownTimer
            );


            track(
              'popup_expired'
            );


            closePopup(
              true,
              false
            );


          }

          else {

            renderCD();

          }


        },

        1000
      );



    track(

      'popup_viewed',

      {
        popup_type:
          'cart_offer'
      }

    );

  }



  /* ==================================================
     CLOSE POPUP
  ================================================== */

  function closePopup(

    expired = false,

    copied = false

  ) {


    clearInterval(
      countdownTimer
    );


    $box.classList.remove(
      'open'
    );


    setTimeout(
      () => {

        $overlay.classList.remove(
          'active'
        );

      },

      220
    );


    if (
      !copied
    ) {


      markDismissed();


      showFloat();


    }

    else {


      hideFloat();


    }

  }



  /* ==================================================
     SELECT OFFER
  ================================================== */

  document

    .querySelector(
      '.sp-offers'
    )

    .addEventListener(

      'click',

      function (e) {


        const card =
          e.target.closest(
            '.sp-offer-card'
          );


        if (!card) return;



        document

          .querySelectorAll(
            '.sp-offer-card'
          )

          .forEach(
            c => {

              c.classList.remove(
                'selected'
              );

            }
          );



        card.classList.add(
          'selected'
        );



        selectedOffer =

          d.offers[

            parseInt(
              card.dataset.index,
              10
            )

          ];



        $codeVal.textContent =
          selectedOffer.code;



        $codeSection.classList.add(
          'visible'
        );


      }

    );



  /* ==================================================
     FALLBACK COPY
  ================================================== */

  function fallbackCopy(
    code
  ) {


    const ta =
      document.createElement(
        'textarea'
      );


    ta.value =
      code;


    ta.style.cssText =
      'position:fixed;opacity:0;';


    document.body.appendChild(
      ta
    );


    ta.select();


    document.execCommand(
      'copy'
    );


    document.body.removeChild(
      ta
    );

  }



  /* ==================================================
     COPY CODE
  ================================================== */

  function copyCode() {


    if (
      !selectedOffer
    ) return;



    const code =
      selectedOffer.code;



    if (
      navigator.clipboard &&
      navigator.clipboard.writeText
    ) {


      navigator.clipboard

        .writeText(
          code
        )

        .catch(
          () =>
            fallbackCopy(
              code
            )
        );


    }

    else {


      fallbackCopy(
        code
      );


    }



    markCopied();



    const exp =
      new Date(

        Date.now()
        +
        3600000

      ).toUTCString();



    document.cookie =

      `discount_code=${code}; path=/; expires=${exp}`;



    track(

      'code_copied',

      {

        code,

        offer_title:
          selectedOffer.title,

        time_left_seconds:
          secondsLeft

      }

    );



    $successSub.textContent =

      `"${code}" copied successfully. Use it at checkout for ${selectedOffer.title.toLowerCase()}.`;



    $success.classList.add(
      'show'
    );



    clearInterval(
      countdownTimer
    );



    setTimeout(

      () => {

        closePopup(
          false,
          true
        );

      },

      1600

    );

  }



  /* ==================================================
     EVENTS
  ================================================== */

  $closeBtn.addEventListener(

    'click',

    function () {


      track(

        'popup_closed',

        {

          time_left_seconds:
            secondsLeft,

          action:
            'x_button'

        }

      );


      closePopup();


    }

  );



  $dismiss.addEventListener(

    'click',

    function () {


      track(

        'popup_closed',

        {

          time_left_seconds:
            secondsLeft,

          action:
            'dismiss'

        }

      );


      closePopup();


    }

  );



  $overlay.addEventListener(

    'click',

    function (e) {


      if (
        e.target ===
        $overlay
      ) {


        track(

          'popup_closed',

          {

            time_left_seconds:
              secondsLeft,

            action:
              'backdrop'

          }

        );


        closePopup();


      }


    }

  );



  $copyBtn.addEventListener(

    'click',

    copyCode

  );



  $floatBtn.addEventListener(

    'click',

    function () {


      track(

        'reminder_clicked',

        {

          time_left_seconds:
            secondsLeft

        }

      );


      sessionStorage.removeItem(
        SK_SHOWN
      );


      showPopup();


    }

  );



  /* ==================================================
     ADD TO CART TRIGGER
  ================================================== */

  function onCartAdd() {


    if (
      getTriggerTime()
    ) return;


    setTriggerTime();


    schedulePopup();

  }



  /* ==================================================
     SCHEDULE
  ================================================== */

  function schedulePopup() {


    const triggerTime =
      getTriggerTime();


    if (
      !triggerTime
    ) return;



    const elapsed =

      (
        Date.now()
        -
        triggerTime
      )

      / 1000;



    const remaining =

      CFG.cartDelaySeconds
      -
      elapsed;



    if (
      remaining <= 0
    ) {


      showPopup();


    }

    else {


      setTimeout(

        showPopup,

        remaining * 1000

      );


    }

  }



  /* ==================================================
     WATCH ADD TO CART BUTTONS
  ================================================== */

  function attachCartButtons() {


    const sel = [

      '[name="add"]',

      '[data-add-to-cart]',

      '.add-to-cart',

      '#add-to-cart',

      '[data-testid="add-to-cart"]',

      '.product-form__cart-submit',

      '.btn-addtocart',

      'button[data-btn-addtocart]',

      '.AddToCart',

      '.add_to_cart_button'

    ].join(',');



    document

      .querySelectorAll(sel)

      .forEach(
        btn => {


          if (
            btn.dataset.spAttached
          ) return;


          btn.dataset.spAttached =
            '1';


          btn.addEventListener(

            'click',

            onCartAdd

          );


        }
      );

  }



  /* ==================================================
     FETCH WATCHER
  ================================================== */

  const _fetch =
    window.fetch;



  window.fetch =
    function (
      input,
      init
    ) {


      const url =

        (
          typeof input ===
          'string'

          ?

          input

          :

          input?.url

        )

        || '';



      if (
        url.includes(
          '/cart/add'
        )
      ) {


        onCartAdd();


      }



      return _fetch.apply(

        this,

        arguments

      );

    };



  /* ==================================================
     XHR WATCHER
  ================================================== */

  const _open =
    XMLHttpRequest
      .prototype
      .open;



  XMLHttpRequest
    .prototype
    .open =

    function (
      method,
      url
    ) {


      if (

        typeof url ===
        'string'

        &&

        url.includes(
          '/cart/add'
        )

      ) {


        onCartAdd();


      }



      return _open.apply(

        this,

        arguments

      );

    };



  /* ==================================================
     INIT
  ================================================== */

  function init() {


    attachCartButtons();



    const triggerTime =
      getTriggerTime();



    if (
      !triggerTime
    ) return;



    if (
      wasCopied()
    ) return;



    if (
      wasShown() &&
      !isFloatVisible()
    ) return;



    schedulePopup();

  }



  /* ==================================================
     DOM READY
  ================================================== */

  if (
    document.readyState ===
    'loading'
  ) {


    document.addEventListener(

      'DOMContentLoaded',

      init

    );


  }

  else {


    init();


  }



  /* ==================================================
     WATCH DYNAMIC BUTTONS
  ================================================== */

  new MutationObserver(

    attachCartButtons

  )

  .observe(

    document.body,

    {

      childList: true,

      subtree: true

    }

  );


})();